const FolderFilled = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 7a2.5 2.5 0 0 1 2.5-2.5h3.142a2.5 2.5 0 0 1 2.12 1.175l.074.12a1.5 1.5 0 0 0 1.272.705H18.5A2.5 2.5 0 0 1 21 9v7a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 16z"
      clipRule="evenodd"
    />
  </>
)
export default FolderFilled
